const index = () => import('./Index');

//2021年云南省“三化”改造试点示范项目
export default {
  routes: [
    {
      path: '/internet/v2021/index',
      name: 'internet_v2021_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/internet/v2021/router.js